import { Directive, Input } from '@angular/core';

@Directive({
  selector: 'button[appButton]',
  host: {
    '[class]': 'variant'
  }
})
export class ButtonDirective {
  @Input('appButton') variant: 'filled' | 'light' | 'warn' = 'filled';
}
